import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Mail } from 'lucide-react';

export const Contact: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50 py-12 px-4">
      <div className="max-w-2xl mx-auto">
        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-2 text-blue-600 hover:text-blue-700 mb-6 transition-colors"
        >
          <ArrowLeft size={20} />
          Back to Login
        </button>

        <div className="bg-white rounded-lg shadow-md p-8 text-center">
          <h1 className="text-3xl font-bold mb-6 text-slate-900">Contact Us</h1>

          <p className="text-slate-600 mb-8 text-lg">
            Have questions or feedback about LessonlyAI?
          </p>

          <div className="bg-blue-50 border-2 border-blue-200 rounded-lg p-8">
            <Mail className="w-12 h-12 text-blue-600 mx-auto mb-4" />
            <p className="text-lg font-semibold mb-3 text-slate-900">Email Us</p>
            <a
              href="mailto:pablo@lessonlyai.com"
              className="text-blue-600 hover:underline text-xl font-medium"
            >
              pablo@lessonlyai.com
            </a>
            <p className="text-sm text-slate-500 mt-4">
              We typically respond within 24 hours
            </p>
          </div>

          <div className="mt-8 pt-6 border-t border-slate-200">
            <h2 className="text-lg font-semibold mb-3 text-slate-900">What can we help with?</h2>
            <ul className="text-slate-600 space-y-2 text-left max-w-md mx-auto">
              <li>• Technical support and bug reports</li>
              <li>• Feature requests and suggestions</li>
              <li>• Questions about lesson generation</li>
              <li>• Account and billing inquiries</li>
              <li>• Partnership opportunities</li>
              <li>• General feedback on the platform</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
